import { MENU_KEYS } from 'constants/menus'
import { CLINIC_CREATE_PATH } from 'constants/routes'
import { EMPTY_ARR, ZERO } from 'constants/usefulConstants'
import React, { FunctionComponent } from 'react'
import { prop, map, pathOr } from 'ramda'
import { TUseDelete, TGetDataFromState, TData } from 'types'
import { Menu } from 'components/Menu'
import Pagination from 'components/Pagination'
import {
  Table,
  TableActions,
  TableRow,
  TableHeader,
  TableCol,
  TableBody
} from 'components/Table'
import { Box, Dropdown, DropdownItem } from 'components/UI'

type Props = {
    data: TGetDataFromState<TData<any>>;
    filterAction: any;
    onEdit: (id) => void;
    deleteData: TUseDelete;
}

const ClinicList: FunctionComponent<Props> = props => {
  const { data, onEdit, deleteData } = props
  const count = pathOr(ZERO, ['data', 'pagination', 'totalItems'], data)
  const list = pathOr(EMPTY_ARR, ['data', 'data'], data)
  const ids = map(prop('_id'), list)
  const actions = (
    <TableActions
      createPath={CLINIC_CREATE_PATH}
    />
  )

  return (
    <div>
      <Menu title="Клиники" module={MENU_KEYS.CLINIC} active={MENU_KEYS.CLINIC} />
      <Box>
        <Table loading={data.loading} list={ids} actions={actions} gutter={30}>
          <TableHeader>
            <TableRow>
              <TableCol span={1}>#</TableCol>
              <TableCol span={7}>Название</TableCol>
              <TableCol span={3}>Номер телефона</TableCol>
              <TableCol span={3}>Лимит пользователей</TableCol>
              <TableCol span={1}> </TableCol>
            </TableRow>
          </TableHeader>
          <TableBody>
            {list.map((item: any, index) => {
              const name = prop('name', item)
              const _id = prop('_id', item)
              const phoneNumber = prop('phoneNumber', item)
              const userLimit = prop('userLimit', item)

              return (
                <TableRow key={index} align="center">
                  <TableCol span={1}>{index + 1}</TableCol>
                  <TableCol span={7}>{name}</TableCol>
                  <TableCol span={3}>{phoneNumber}</TableCol>
                  <TableCol span={3}>{userLimit}</TableCol>
                  <TableCol span={1}>
                    <Dropdown>
                      <DropdownItem onClick={() => onEdit(_id)}>
                        Изменить
                      </DropdownItem>
                      <DropdownItem onClick={() => deleteData.onSubmit(_id)}>
                        Удалить
                      </DropdownItem>
                    </Dropdown>
                  </TableCol>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </Box>
      <Pagination count={count} />
    </div>
  )
}

export default ClinicList
